import { render, staticRenderFns } from "./AssetSlide.vue?vue&type=template&id=a4b98146&scoped=true&"
import script from "./AssetSlide.vue?vue&type=script&lang=js&"
export * from "./AssetSlide.vue?vue&type=script&lang=js&"
import style0 from "./AssetSlide.vue?vue&type=style&index=0&id=a4b98146&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b98146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4b98146')) {
      api.createRecord('a4b98146', component.options)
    } else {
      api.reload('a4b98146', component.options)
    }
    module.hot.accept("./AssetSlide.vue?vue&type=template&id=a4b98146&scoped=true&", function () {
      api.rerender('a4b98146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/AssetSlide.vue"
export default component.exports